import { type AppRouter } from '../../server/appRouter';
import { httpBatchLink, type TRPCLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
import superjson from 'superjson';

export const trpc = createTRPCReact<AppRouter>();

const trpcLinks: Array<TRPCLink<AppRouter>> = [
  httpBatchLink({
    fetch(url, options) {
      return fetch(url, {
        ...options,
        credentials: 'include',
      });
    },
    transformer: superjson,
    url: '/api',
  }),
];

export const trpcLinksFactory = () => trpcLinks;
